export default function calculateM2(
  selectedValues,
  getDimensionCode,
  getValueCode
) {
  function getValueCodeForDimension(values, dimensionCode) {
    const foundValue = values.find(value => {
      const dimensionCodeForValue = getDimensionCode(value);

      return dimensionCodeForValue === dimensionCode;
    });

    return foundValue ? getValueCode(foundValue) : null;
  }

  // Value code if CVY has default width dimension
  const widthCode = getValueCodeForDimension(selectedValues, "width");
  // Value code if CVY has default depth dimension
  const depthCode = getValueCodeForDimension(selectedValues, "depth");
  // Value code if CVY has *combined* width and depth dimension
  const combinedWidthAndDepthCode = getValueCodeForDimension(
    selectedValues,
    "widthDepth"
  );
  // Value code if CVY has addon-frame dimension (second width)
  const secondWidthCode = getValueCodeForDimension(selectedValues, "width2");

  const widthInMm = combinedWidthAndDepthCode
    ? parseInt(combinedWidthAndDepthCode.slice(0, 4))
    : parseInt(widthCode, 10);
  const depthInMm = combinedWidthAndDepthCode
    ? parseInt(combinedWidthAndDepthCode.slice(5, 9))
    : parseInt(depthCode, 10);

  const result = secondWidthCode
    ? widthInMm * depthInMm + parseInt(secondWidthCode, 10) * depthInMm
    : widthInMm * depthInMm;
  
  const m2 = result ? (result / 1000000).toFixed(1) : "";
  
  return m2;
}
